import { Container, Row } from "reactstrap";
import LoginSimpleContainer from "../../Componant/Authentication/LoginSimple";

const LoginSimple = () => {
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <LoginSimpleContainer />
      </Row>
    </Container>
  );
};

export default LoginSimple;
